// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"72":"d3eaa0b7","89":"74438450","100":"9fbd13d1","111":"9a78865f","343":"fae76a73","418":"64063679","452":"d06f73ba","492":"372287b1","499":"af4bd07a","500":"a24314c1","552":"ed92e01a","578":"83229b51","631":"5db23f45","783":"e86301b1","918":"f7d892ff","941":"6fc4d5db"}[chunkId] + ".js";
};